/**
 * Module contracts kya
 * @module app.kya.contracts
 */
define([
    'angular',
    'modules/kya/contracts/controllers/contractsCtrl',
    'modules/kya/contracts/controllers/modals/cancelReplaceContractCtrl',
    'modules/kya/contracts/factories/contractProvider',
    'modules/kya/contracts/factories/contractService'
], function(angular) {


    /**
     * Configure routing
     * @param $routeProvider
     */
    function kiaContractsRouter($routeProvider) {
        $routeProvider.when('/kya/contracts/', {
            templateUrl: 'kya/contracts/partials/data.html',
            controller: 'ContractsCtrl',
            controllerAs: 'contractsCtrl',
            params: {
                menuTitle: "Informations sur l'agent"
            }
        });
    }

    kiaContractsRouter.$inject = ['$routeProvider'];

    angular
        .module('app.kya.contracts', [
            'app.kya.contracts.contractsCtrl',
            'app.kya.contracts.cancelReplaceContractCtrl',
            'app.kya.contracts.contractProvider',
            'app.kya.contracts.contractService'
        ])
        .config(kiaContractsRouter);
});
